document.addEventListener("algolia.hooks.initialize", function () {

  algoliaShopify.hooks.registerHook(
    "beforeAutocompleteProductTemplate",
    function (_defaultTemplate, templateOptions, distinct, itemLink, trackSearchAttribution) {
      const { html, item, components } = templateOptions;    
      
const pnrHighlight = item._highlightResult?.meta?.MMG?.Product_spec?.ALGEMEEN?.Partnummer;
const partnummer_flat = pnrHighlight?.matchedWords?.length > 0 && pnrHighlight?.matchLevel !== "none"
  ? pnrHighlight
  : { value: item.meta?.MMG?.Product_spec?.ALGEMEEN?.Partnummer, matchLevel: "none" };

const flatItem = {
  ...item,
  partnummer_flat,
  _highlightResult: {
    ...item._highlightResult,
    partnummer_flat
  }
};

      return html`
    <a
      href="${itemLink}"
      class="aa-ItemLink aa-ProductItem"
      onClick="${() => trackSearchAttribution(item)}"
    >
      <div class="aa-ItemContent">
        <div class="aa-ItemPicture aa-ItemPicture--loaded">
          <img
            src="${algoliaShopify.helpers.renderImage(item, 125).src}"
            srcset="${algoliaShopify.helpers.renderImage(item, 125).srcset}"
            sizes="${algoliaShopify.helpers.renderImage(item, 125).sizes}"
            alt="${item.title}"
          />
        </div>
        <div class="aa-ItemContentBody">
          <div class="aa-ItemContentBrand">
            ${
              item.product_type &&
              components.Highlight({ hit: item, attribute: "product_type" })
            }
           removing vendor
          </div>
          <div class="aa-ItemContentTitleWrapper">
            <div class="aa-ItemContentTitle">
              ${components.Highlight({ hit: item, attribute: "title" })}
              <span class="algolia-variant">
                ${algoliaShopify.helpers.variantTitleAddition(item, distinct)}
              </span>
            </div>
          </div>

      <div style="display: flex; align-items: center; font-size: 14px;">
        <span class="sku">
          ${components.Highlight({ hit: item, attribute: "sku" })}
        </span>
        ${
          item.meta.MMG.Product_spec.ALGEMEEN.Partnummer !== item.sku
            ? html`<span class="separator" style="margin: 0 0.25em;">-</span>
                  <span class="partnummer">
                   ${components.Highlight({ hit: flatItem, attribute: "partnummer_flat" })}
                  </span>`
            : ''
        }
      </div>

          <div class="aa-ItemContentPrice">
            <div class="aa-ItemContentPriceCurrent">
                        ${
                          (() => {
                            let finalPrice;

                            if (window.isValidCustomer) {
                              // Logged-in verified B2B customer → net price
                              finalPrice = item.price;
                              return finalPrice
                                .toLocaleString('nl-NL', { style: 'currency', currency: 'EUR' })
                                .replace(/\u00A0/, '');
                            } else {
                              // Not logged in → consumer price + VAT
                              finalPrice = item.price * 1.21;
                              return 'Consumentenadviesprijs ' + finalPrice
                                .toLocaleString('nl-NL', { style: 'currency', currency: 'EUR' })
                                .replace(/\u00A0/, '');
                            }
                          })()
                        }
            </div>
          </div>
        </div>
      </div>
    </a>
  `;
    }
  );
});
